import {
  Divider,
  Grid,
  Typography,
} from "@mui/material";
// import { useTranslation } from "react-i18next";
import ExpandingList from "./ExpandingList";
import React, { useEffect } from "react";
import * as Util from "../../services/global.service";
const PortfolioDetailCollapseList = (props) => {
  const { data } = props
  const formatData = (data, defaults) => {
    if (data !== null && data !== undefined && data !== "") {
      return data;
    }
    return defaults;
  }


  const code = (data) => {
    let text = ""
    if (data !== undefined && data !== null && data !== "" && data !== "other") {
      text = data + "- "
    }
    return text
  }

  useEffect(() => {
    setDetailList(itemDetail())
  }, [data]);

  const itemDetail = () => {
    const itemDetailList = []
    if (data.teaching !== undefined && data.teaching !== null) {
      itemDetailList.push({
        type: data?.workType,
        qty: 2,
        items: [
          {
            id: 'a1',
            title: code(data?.workSubypeCode) + data?.workSubtype,
            order: 1,
            selected: true,
            data: [
              // { key: "รหัส Class", value: data?.teaching?.classID },
              { key: "ชื่อหลักสูตร", value: data?.teaching?.programStudy?.description },
              { key: "คณะ", value: data?.teaching?.insitue },
              { key: "ภาค", value: data?.teaching?.courseSession?.description },
              { key: "กลุ่มวิชา", value: data?.teaching?.courseGroup?.description },
              { key: "หลักสูตรภาษา", value: data?.teaching?.courseLanguage?.description },
              { key: "วิชาใหม่/วิชาเดิม", value: data?.teaching?.isNew === true ? "วิชาใหม่" : "วิชาเดิม" },
              { key: "หน่วยกิต", value: formatData(data?.teaching?.credit, "0") },
              { key: "การได้รับอนุมัติ", value: data?.teaching?.isApprove === "y" ? "หลักสูตรที่ได้รับการอนุมัติ" : "หลักสูตรที่ไม่ได้รับการอนุมัติ" },
              { key: "ภาคเรียนที่", value: data?.teaching?.semeter },
              { key: "ปีการศึกษา (ปีพ.ศ.) ", value: data?.teaching?.academicYear },
              { key: "ชั่วโมงสอนทั้งหมด", value: formatData(data?.teaching?.hours, "0") + " ชั่วโมง" },
              { key: "ชั่วโมงสอนจริง", value: formatData(data?.teaching?.hoursActual, "0") + " ชั่วโมง" },
              { key: "จำนวนงานวิจัยนักศึกษาแผน (ชิ้น)", value: formatData(data?.teaching?.researchCount, "0") },
              { key: "จำนวนงานวิจัยนักศึกษาตามจริง (ชิ้น)", value: formatData(data?.teaching?.researchCountActual, "0") },
              { key: "บทบาท", value: data?.teaching?.teachRole?.description },
              { key: "สถานะการเป็นกรรมการ", value: data?.teaching?.committeeStatus?.description },
              { key: "หมายเหตุ", value: data?.portfolio?.remark },
            ]
          }
        ]
      })
    } else if (data.training !== undefined && data.training !== null) {
      itemDetailList.push({
        type: data?.workType,
        qty: 2,
        items: [
          {
            id: 'a1',
            title: code(data?.workSubypeCode) + data?.workSubtype,
            order: 1,
            selected: true,
            data: [
              { key: "ประเภทการฝึกอบรม", value: data?.training?.trainSubtype?.description },
              { key: "บทบาท", value: data?.training?.positionTH },
              { key: "หน่วยงานที่รับผิดชอบ", value: data?.training?.faculty },
              { key: "หน่วยกิต", value: formatData(data?.training?.credit, "0") },
              { key: "ชั่วโมงของหลักสูตร", value: formatData(data?.training?.hours, "0") + " ชั่วโมง" },
              { key: "ชั่วโมงสอนจริง", value: formatData(data?.training?.hoursActual, "0") + " ชั่วโมง" },
              { key: "วันเริ่มต้นจัดทำ", value: formatData(data?.training?.startAt, false) === false ? "-" : Util.dateDayFormat(data?.training?.startAt) },
              { key: "วันที่เสร็จสิ้น", value: formatData(data?.training?.endAt, false) === false ? "-" : Util.dateDayFormat(data?.training?.endAt) },
              { key: "เงินรายได้เข้าสถาบันตามแผน", value: formatData(data?.training?.amount, "0") + " บาท" },
              { key: "เงินรายได้เข้าสถาบันตามจริง", value: formatData(data?.training?.amountActual, "0") + " บาท" },
              { key: "หมายเหตุ", value: data?.portfolio?.remark },
            ]
          }
        ]
      })
    } else if (data.academicPublishing !== undefined && data.academicPublishing !== null) {
      itemDetailList.push({
        type: data?.workType,
        qty: 2,
        items: [
          {
            id: 'a1',
            title: code(data?.workSubypeCode) + data?.workSubtype,
            order: 1,
            selected: true,
            data: [
              { key: "ประเภทผลงาน", value: data?.academicPublishing?.academicPublishingWorksSubType?.description },
              { key: "ประเภทการเผยแพร่", value: data?.academicPublishing?.academicPublishingType?.description },
              { key: "ระดับการเผยแพร่", value: data?.academicPublishing?.academicPublishingLevel?.description },
              { key: "ระดับของหน่วยงาน", value: data?.academicPublishing?.academicPublishingDepartmentLevel?.description },
              { key: "ประเภทวิจัยภายใน", value: data?.academicPublishing?.academicPublishingInternalType?.description },
              { key: "ฐานข้อมูล", value: data?.academicPublishing?.academicPublishingDatabase?.description },
              { key: "ตำแหน่ง", value: data?.academicPublishing?.academicPublishingPosition?.description },
              { key: "จำนวนผู้ร่วมตีพิมพ์", value: formatData(data?.academicPublishing?.totalCoAuthor, "0") },
              { key: "ตีพิมพ์ร่วมกับนักศึกษา", value: data?.academicPublishing?.isCoAuthor === true ? "ตีพิมพ์ร่วมกับนักศึกษา" : "ไม่ได้ตีพิมพ์ร่วมกับนักศึกษา" },
              { key: "ภาษาที่ใช้ในการตีพิมพ์", value: data?.academicPublishing?.academicPublishingLanguage?.description },
              { key: "ปริมาณงานแผน", value: formatData(data?.academicPublishing?.amount, "0") + " " + data?.unit },
              { key: "ปริมาณงานจริง", value: formatData(data?.academicPublishing?.amountActual, "0") + " " + data?.unit },
              { key: "ประเภทการปรับปรุง", value: data?.academicPublishing?.isRevise === true ? "ปรับปรุง" : "ผลงานใหม่" },
              { key: "สัดส่วนการปรับปรุง", value: data?.academicPublishing?.reviseRate },
              { key: "วันเริ่มต้นจัดทำ", value: formatData(data?.academicPublishing?.startAt, false) === false ? "-" : Util.dateDayFormat(data?.academicPublishing?.startAt) },
              { key: "วันที่เผยแพร่", value: formatData(data?.academicPublishing?.releaseAt, false) === false ? "-" : Util.dateDayFormat(data?.academicPublishing?.releaseAt) },
              { key: "วันที่เสร็จสิ้น", value: formatData(data?.academicPublishing?.endAt, false) === false ? "-" : Util.dateDayFormat(data?.academicPublishing?.endAt) },
              { key: "หมายเหตุ", value: data?.portfolio?.remark },
            ]
          }
        ]
      })
    } else if (data.academicService !== undefined && data.academicService !== null) {
      itemDetailList.push({
        type: data?.workType,
        qty: 2,
        items: [
          {
            id: 'a1',
            title: code(data?.workSubypeCode) + data?.workSubtype,
            order: 1,
            selected: true,
            data: [
              { key: "ระดับของหน่วยงาน", value: data?.academicService?.academicServiceDepartmentLevel?.description },
              { key: "ปริมาณงานแผน", value: formatData(data?.quantity, "0") + " " + data?.unit },
              { key: "ปริมาณงานจริง", value: formatData(data?.quantityActual, "0") + " " + data?.unit },
              { key: "ตำแหน่ง", value: data?.academicService?.academicServicePosition?.description },
              { key: "จำนวนผู้ร่วมตีพิมพ์", value: formatData(data?.academicService?.totalCoAuthor, "0") },
              { key: "วันเริ่มต้นจัดทำ", value: formatData(data?.academicService?.startAt, false) === false ? "-" : Util.dateDayFormat(data?.academicService?.startAt) },
              { key: "วันที่ดำเนินการเสร็จสิ้น", value: formatData(data?.academicService?.endAt, false) === false ? "-" : Util.dateDayFormat(data?.academicService?.endAt) },
              { key: "หมายเหตุ", value: data?.portfolio?.remark },
            ]
          }
        ]
      })
    } else {
      itemDetailList.push({
        type: data?.workType,
        qty: 2,
        items: [
          {
            id: 'a1',
            title: code(data?.workSubypeCode) + data?.workSubtype,
            order: 1,
            selected: true,
            data: [
              { key: "ปริมาณงานแผน", value: formatData(data?.portfolio?.quantity, "0") + " " + data?.unit },
              { key: "ปริมาณงานจริง", value: formatData(data?.portfolio?.quantityActual, "0") + " " + data?.unit },
              { key: "วันเริ่มต้นจัดทำ", value: formatData(data?.portfolio?.startAt, false) === false ? "-" : Util.dateDayFormat(data?.portfolio?.startAt) },
              { key: "วันที่ดำเนินการเสร็จสิ้น", value: formatData(data?.portfolio?.endAt, false) === false ? "-" : Util.dateDayFormat(data?.portfolio?.endAt) },
              { key: "หมายเหตุ", value: data?.portfolio?.remark },
            ]
          }
        ]
      })
    }
    return itemDetailList;
  }

  const [stateItemDetailList, setDetailList] = React.useState(itemDetail());

  const toggleCollapseList = (val) => {
    let newState = stateItemDetailList.map(parent => {
      let data = parent.items.map(item => {
        if (item.id === val.id) {
          item.selected = !item.selected
        } else {
          item.selected = false
        }
        return item
      })
      parent.data = data
      return parent
    })
    setDetailList(newState)
  }

  const list = stateItemDetailList.map((parent, index) => {
    let typeList = []
    let mainItemList = []
    let itemDetailListRender = []
    // child element list
    parent.items.forEach(child => {
      itemDetailListRender = []
      child.data.forEach(item => {
        itemDetailListRender.push(
          <Grid container spacing={4} mb={1} sx={{ padding: "5px 0px" }}>
            <Grid item lg={1}></Grid>
            <Grid item lg={3.5}>
              <Typography fontSize={18} lineHeight="25px" fontWeight="400" sx={{ color: "#A3A3A3" }}>{item.key}</Typography>
            </Grid>
            <Grid item lg={7.5}>
              <Typography fontSize={18} lineHeight="25px" fontWeight="400">{formatData(item.value, "-")}</Typography>
            </Grid>
          </Grid>
        );
      })
      typeList.push(
        <React.Fragment key={`${child.title}-${index}`}>
          <ExpandingList item={itemDetailListRender} data={child} selected={child.selected} toggleSelected={toggleCollapseList} />
          {index < stateItemDetailList.length - 1 ?
            (
              <Grid item lg={12} pt={1} pb={1}>
                <Divider />
              </Grid>
            )
            : ""
          }
        </React.Fragment>
      )
    })

    // main element list
    mainItemList.push(
      <React.Fragment key={index}>
        <Grid container spacing={4} style={{ pointerEvents: 'none' }}>
          <Grid item lg={12}>
            <Typography fontSize={20} fontWeight="500" sx={{ paddingTop: "10px", paddingBottom: "10px" }}>
              {parent.type}
            </Typography>
            {/* <Typography fontWeight="200" variant="h6">
              จำนวน: { parent.qty } ประเภท
            </Typography> */}
          </Grid>
        </Grid>
        <Grid item lg={12} pt={1} pb={1}>
          <Divider />
        </Grid>
        {typeList}
      </React.Fragment>
    )

    return mainItemList
  })
  return list
}

export default PortfolioDetailCollapseList;
